import { HTMLAttributes } from "react"

export default function Plausible(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="46"
      height="60"
      viewBox="0 0 46 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.2456 22.6027C44.1545 33.0584 35.0129 40.83 24.5003 40.83H20.4525V50.4C20.4525 55.7019 16.1545 60 10.8525 60H3.35999C1.50432 60 0 58.4956 0 56.64V36.9375L5.03807 29.8688C5.94988 28.5895 7.62603 28.1121 9.07506 28.719L11.9408 29.9193C13.3853 30.5243 15.0562 30.0488 15.9656 28.7738L22.6828 19.3567C23.5899 18.0849 25.2572 17.6116 26.6972 18.2169L32.2171 20.5373C33.6601 21.144 35.3308 20.6693 36.2394 19.3946L42.6988 10.332C44.7236 13.8918 45.7133 18.1208 45.2456 22.6027Z"
        fill="url(#paint0_linear_1535_335)"
      />
      <path
        d="M3.29209 28.8726C4.11538 27.7175 5.313 26.8291 6.70596 26.5612C7.79212 26.3523 8.86287 26.4619 9.85321 26.8767L12.7182 28.0767C12.8833 28.1458 13.0571 28.1808 13.2347 28.1808C13.6713 28.1808 14.0835 27.9684 14.3373 27.6125L20.9316 18.3677C21.7547 17.2137 22.952 16.3267 24.344 16.0594C25.4262 15.8516 26.4904 15.9605 27.4723 16.3732L32.9921 18.6937C33.1587 18.7637 33.3339 18.7992 33.5128 18.7992C33.948 18.7992 34.3585 18.5878 34.6108 18.2338L41.53 8.52606C37.8272 3.36444 31.7802 0 24.945 0H3.35999C1.50432 0 0 1.50432 0 3.35999V33.4916L3.29209 28.8726Z"
        fill="url(#paint1_linear_1535_335)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1535_335"
          x1="14.8413"
          y1="22.5436"
          x2="27.4731"
          y2="44.6493"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#909CF7" />
          <stop offset="1" stopColor="#4B38D8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1535_335"
          x1="7.98379"
          y1="-1.35829"
          x2="21.001"
          y2="21.4218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#909CF7" />
          <stop offset="1" stopColor="#4B38D8" />
        </linearGradient>
      </defs>
    </svg>
  )
}
